import Vue from 'vue';
import Vuex from 'vuex';
import { apiRequest } from '@/utils';
import { setUserUniqueId, setMemberTypeName } from '@/utils/finder.js';
import Sentry from '@/sentry';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isRouterAlive: true,
        token: sessionStorage.getItem('token') || localStorage.getItem('token') || '',
        wxSuccess: () => {},
        // 时间选择
        datePicker: {},
        // 经纬度
        latitude: 0,
        longitude: 0,
        currentCityName: '',
        selectedCityName: '',
        locationInfo: {},
        newHotelShowOthers: 1,
        bindAppealInfo: null,
        userInfo: null, // 用户信息
        verifyInfo: null,
        smDeviceId: '', // 数美设备id
        tdBlackbox: '', // 同盾设备信息
    },
    mutations: {
        setRouterStatus(state, payload) {
            state.isRouterAlive = payload;
        },
        setToken(state, payload) {
            state.token = payload;
        },
        setWxReadySuccess(state, payload = () => {}) {
            state.wxSuccess = payload;
        },
        setDatePicker(state, datePicker) {
            state.datePicker = datePicker;
        },
        setLatitude(state, latitude) {
            state.latitude = latitude;
        },
        setLongitude(state, longitude) {
            state.longitude = longitude;
        },
        setCurrentCityName(state, currentCityName) {
            state.currentCityName = currentCityName;
        },
        setSelectedCityName(state, selectedCityName) {
            state.selectedCityName = selectedCityName;
        },
        setLocationInfo(state, locationInfo) {
            state.locationInfo = locationInfo;
        },
        setNewHotelShowOthers(state, newHotelShowOthers) {
            state.newHotelShowOthers = newHotelShowOthers;
        },
        setBindAppealInfo(state, bindAppealInfo) {
            state.bindAppealInfo = bindAppealInfo;
        },
        setUserInfo(state, info) {
            state.userInfo = info;
            setUserUniqueId(info?.mebId || ''); // 重置埋点的公用参数
            setMemberTypeName(info?.mebType || ''); // 重置埋点的公用参数
            Sentry.setUser({ id: info?.mebId || '' });
        },
        setVerifyInfo(state, info) {
            state.verifyInfo = info;
        },
        setSmDeviceId(state, smDeviceId) {
            state.smDeviceId = smDeviceId;
        },
        setTdBlackbox(state, tdBlackbox) {
            state.tdBlackbox = tdBlackbox;
        },
    },
    actions: {
        async fetchUserInfo({ commit }) {
            const { result } = await apiRequest('get', '/user/getUserCenterInfo', {}, { hideToast: true });
            if (result?.personalInfo) {
                commit('setUserInfo', result.personalInfo);
            }
            console.log('fetchUserInfo 存储用户信息');
        },
    },
});
